import { Report63Container } from "../../../containers/SupportSystem/Reports/Report63Container";
export function Report63Page() {
    return (
        <Report63Container />
    );

}